import React from 'react';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Retail Price top entity chart with single dropdown
 */
const AtlasV2PricesTopEntityChart = () => {
  const mainEntityType = useMainEntityType();
  return (
    <AtlasV2DropdownMetricColumnChart
      indexName="sales"
      fieldName="retailPrice"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },

        {
          id: 'parentBrandId',
          label: 'Manufacturer'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
      titlePrefix="Retail Price by"
    />
  );
};
export default AtlasV2PricesTopEntityChart;
